import HouseholdComponent from './household.js';
import VillageRequestComponent from './villagerequest.js';
import './App.css';
import { useState, useEffect, } from 'react';
import logo from './village.jpeg';
import { v4 as uuidv4 } from 'uuid';

// https://api.parent-ai.com/getVillageRequest?villageRequestId=8376EF89-7AFF-44FD-85F0-8AD127EC15FE&phoneNumber=+14155553695&token=A41D26BB-AB73-4433-83A1-863E6F659C2D"
//http://koy.parent-ai.com/villageRequest/?villageRequestId=8376EF89-7AFF-44FD-85F0-8AD127EC15FE&phoneNumber=%2B14155553695&token=A41D26BB-AB73-4433-83A1-863E6F659C2D
//http://localhost:3000/villageRequestLocal/?villageRequestId=8376EF89-7AFF-44FD-85F0-8AD127EC15FE&phoneNumber=%2B14155553695&token=A41D26BB-AB73-4433-83A1-863E6F659C2D
const VillageRequestPage = () => {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    // Html escape the phone number
    const phoneNumber = params.get('phoneNumber');


    const [villageRequestData, setVillageRequestData] = useState('');
    useEffect(() => {
        const getVillageRequestData = async () => {
            try {
                const villageRequestResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/getVillageRequest?phoneNumber=` + encodeURIComponent(phoneNumber) + `&villageRequestId=` + params.get('villageRequestId')
                    + `&token=` + params.get('token'), {
                    method: 'GET',
                    credentials: 'include'
                });

                if (villageRequestResponse.status === 200) {
                    const villageRequestJson = await villageRequestResponse.json();
                    setVillageRequestData(villageRequestJson);
                } else {
                    console.error("Error getting household data");
                }
            } catch (error) {
                console.error('Error getting household data:', error);
            }
        };

        getVillageRequestData();
    }, []); // Pass an empty array as the dependency list to run the effect only on mount

    console.log(params.get('shareToken'));

    return (
        <div className="App">
            <div className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
            </div>
            <div className="App-body App-body-center">
                <div>
                    {villageRequestData ? <VillageRequestComponent key={uuidv4()} token={params.get('token')} guardianId={"phone:" + phoneNumber} data={villageRequestData} /> : <p>Loading...</p>}
                </div>
            </div>
            <footer className="App-footer">
                <hr />
                <p>&copy; {(new Date().getFullYear())} Parent-AI, Inc. All rights reserved.</p>
                <p>
                    <a href="tos.html">Terms of Service</a> |
                    <a href="privacypolicy.html">Privacy Policy</a>
                </p>
            </footer>
        </div>
    );
}

export default VillageRequestPage;
//{familyData ? <VillageRequestComponent key={uuidv4()} data={villageRequestData} /> : <p>Loading...</p>}

// 
//  https://koy.parent-ai.com/showHousehold/?shareToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODAwNjE4OTUsImlkIjoiYzYwMTkzODMtMjdlYS00MTk4LTljMDEtNWY5MjA4ZDkwZTAzIn0.44zyLmDolMumN2BS0elcqj-oCGjo41WULbjJPF3zN80